import { render, staticRenderFns } from "./VRecurrent.vue?vue&type=template&id=4482a0ac&scoped=true"
import script from "./VRecurrent.vue?vue&type=script&lang=js"
export * from "./VRecurrent.vue?vue&type=script&lang=js"
import style0 from "./VRecurrent.vue?vue&type=style&index=0&id=4482a0ac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4482a0ac",
  null
  
)

export default component.exports